import * as ActionTypes from "../Types/ActionTypes";

export const Users = (
  state = {
    isLoading: true,
    errMess: null,
    users: [],
    usersDummy: [],
    isLoadingDummy: true,
    // productid: [],
    // productorder: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.FETCH_USERS:
      return {
        ...state,
        isLoading: false,
        errMess: null,
        users: action.payload,
      };
    
    case ActionTypes.USERS_LOADING:
      return { ...state, isLoading: true, errMess: null, users: [] };

    case ActionTypes.USERS_FAILED:
      return {
        ...state,
        isLoading: false,
        errMess: action.payload,
        users: [],
      };
      case ActionTypes.FETCH_DUMMY_USERS:
      return {
        ...state,
        isLoadingDummy: false,
        errMess: null,
        usersDummy: action.payload,
      };
    case ActionTypes.DUMMY_USERS_LOADING:
      return { ...state, isLoadingDummy: true, errMess: null, usersDummy: [] };

    case ActionTypes.DUMMY_USERS_FAILED:
      return {
        ...state,
        isLoadingDummy: false,
        errMess: action.payload,
        usersDummy: [],
      };

    default:
      return state;
  }
};
